import Component from '@glimmer/component';
import { useQuery } from 'glimmer-apollo';
import { on } from '@ember/modifier';
import config from 'embroil/config/environment';
import StreamPreview from '../../stream/stream-preview';
import { log } from '../../../helpers/log';
import { eq } from '../../../helpers/article-type';
import LoadingSpinner from '../../ui/loading-spinner';
import { TWITCH_STREAMS_QUERY, TWITCH_STREAMS_SIMPLE_QUERY } from '../../../gql/queries/twitch-streams';

export default class LiveStreamsComponent extends Component {
  query = useQuery(this, () => {
    // If streams are provided as a prop, don't make a query
    if (this.args.streams) {
      return null;
    }
    return [
      TWITCH_STREAMS_SIMPLE_QUERY,
      {
        variables: {
          limit: 3
        },
      },
    ];
  });

  get streams() {
    // Use provided streams if available, otherwise use query data
    return this.args.streams || this.query.data?.twitchStreams || [];
  }

  get liveCount() {
    return this.streams.length;
  }

  get isLoading() {
    return !this.args.streams && this.query?.loading;
  }

  get hasError() {
    return !this.args.streams && this.query?.error;
  }

  <template>
    <div class='widget-sidebar'>
      <div class='section-title-wrap violet'>
        <h2 class='section-title medium'>
          Twitch Streams
          {{#if this.liveCount}}
            <span class='count'>({{this.liveCount}})</span>
          {{/if}}
        </h2>
        <div class='section-title-separator'></div>
      </div>
      <div class='stream-preview-showcase grid-1col centered gutter-small'>
        {{#if this.isLoading}}
          <LoadingSpinner @text="Loading streams..." @centered={{true}} />
        {{else if this.hasError}}
          <div class='error-message'>
            <p>Failed to load streams. Please try again later.</p>
          </div>
        {{else if (eq this.streams.length 0)}}
          <div class='no-streams-message'>
            <p>No streams are currently live.</p>
          </div>
        {{else}}
          {{#each this.streams as |stream|}}
            <StreamPreview @stream={{stream}} />
          {{/each}}
        {{/if}}
      </div>
    </div>
  </template>
}
